module.exports = __webpack_public_path__ + "static/img/his-Asset 79.4486e49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/his-Asset 79.png
// module id = Dvr2
// module chunks = 2